import { isNonEmptyString } from '@sniptt/guards';

import { SENTRY_DSN } from '@/error-reporting/constants/SentryDsn';
import { loadSentry } from '@/error-reporting/utils/loadSentry';

// Called once at start-up: with a DSN, Sentry loads in the background and
// also catches errors outside React (event handlers, rejected promises).
export const initializeErrorReporting = () => {
  if (!isNonEmptyString(SENTRY_DSN)) {
    return;
  }

  // Error alerts must never break the app: a blocked download is ignored.
  loadSentry(SENTRY_DSN).catch(() => undefined);
};
